import userNotificationService from "./Service";
import { Promise } from "es6-promise";

const getUserNotifications = (params) => {
  return new Promise(function(resolve) {
    resolve(userNotificationService.fetchUserNotifications(params));
  });
};

const postBulkMarkReadNotification = (params) => {
  return new Promise(function(resolve) {
    resolve(userNotificationService.bulkMarkReadNotification(params));
  });
};

const deleteBulkMarkDeleteNotification = (params) => {
  return new Promise(function(resolve) {
    resolve(userNotificationService.bulkMarkDeleteNotification(params));
  });
};

export const userNotificationsActions = {
  getUserNotifications,
  postBulkMarkReadNotification,
  deleteBulkMarkDeleteNotification,
};